import { render, staticRenderFns } from "./lawsuit-party-authentications.vue?vue&type=template&id=ee72aefe&"
import script from "./lawsuit-party-authentications.vue?vue&type=script&lang=js&"
export * from "./lawsuit-party-authentications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports